import { DefaultState, IState } from './state';
import { Keys, Types } from './actions/types';

const updatePersisteAuthState = (state: IState) => {
    localStorage.setItem('persistedAuthState', JSON.stringify(state));
    //(window as any).initialReduxState = newGlobalState;
}

export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        case Keys.LOGIN_REQUEST:
            return {
                ...state,
                isFetching: true,
                error: null
            };
        case Keys.LOGIN_SUCCESS:

            let loggedInState = {
                ...state,
                isFetching: false,
                profile: action.payload.profile
            }
            updatePersisteAuthState({...loggedInState});
            return loggedInState;

        case Keys.LOGIN_ERROR:
            return {
                ...state,
                isFetching: false,
                error: action.error
            };
        case Keys.LOGOUT:
            let loggedOutState = {
                ...state,
            };
            updatePersisteAuthState(loggedOutState);
            return loggedOutState;
        default:
            return state;
    }
}